import { useQuery } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';

export const luxPlusScheduleDefaultsQueryKeys = {
  all: ['lux-plus-schedule-defaults'] as const,
  list: () => [...luxPlusScheduleDefaultsQueryKeys.all, 'list'] as const,
};

export function useGetLuxPlusScheduleDefaults() {
  return useQuery({
    queryKey: luxPlusScheduleDefaultsQueryKeys.list(),
    queryFn: ({ signal }) => OffersService.getLuxPlusScheduleDefaults({ signal }),
  });
}
